import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Select from 'components/Select';
import criteriaElementVariants, { VARIANT_CODE } from '../constants/criteriaElement.variants'
import getObjectValue from 'libs/getObjectValue'
import RangeVariant from './elementVariants/RangeVariant';
import SmallerVariant from './elementVariants/SmallerVariant';
import BiggerVariant from './elementVariants/BiggerVariant';
import ErrorText from 'components/ErrorText';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';

const style = theme => ({
	root: {
		'&>*': {
			marginRight: theme.spacing(1),
			'&:last-child': {
				flexGrow: 1,
				textAlign: 'right'
			}
		}
	},
	select: {
		width: 130,
	},
})

function CriteriaElement({
	classes,
	index,
	formikProps,
	onDelete,
	isLast,
	disabled
}) {
	const criterionId = 'intervalList';
	const variantId = `${criterionId}.${index}.type`;
	const variant = getObjectValue(variantId, formikProps.values);
	const editable = getObjectValue('_editable', formikProps.values, false);

	const getVariant = () => {

		switch (variant) {
			case VARIANT_CODE.RANGE: return <RangeVariant isLast={isLast} index={index} formikProps={formikProps} disabled={disabled} />
			case VARIANT_CODE.SMALLER: return <SmallerVariant isLast={isLast} index={index} formikProps={formikProps} disabled={disabled} />
			case VARIANT_CODE.BIGGER: return <BiggerVariant isLast={isLast} index={index} formikProps={formikProps} disabled={disabled} />
			default: return '';
		}
	}

	const getErrorIds = () => {
		let arrayIds = [`${criterionId}.${index}.value`]
		switch (variant) {
			case VARIANT_CODE.RANGE:
				arrayIds.push(`${criterionId}.${index}.from`)
				arrayIds.push(`${criterionId}.${index}.to`)
				break;
			case VARIANT_CODE.SMALLER:
				arrayIds.push(`${criterionId}.${index}.to`)
				break;
			case VARIANT_CODE.BIGGER:
				arrayIds.push(`${criterionId}.${index}.from`)
				break;
			default: break;
		}
		return arrayIds;
	}
	
	return (
		<ErrorText idList={getErrorIds()} formikProps={formikProps}>
			<GridBlock className={classes.root} alignItems='center'>
				<Typography variant='body1'>
					{index + 1}.
				</Typography>
				<Select
					className={classes.select}
					formikProps={formikProps}
					items={criteriaElementVariants}
					id={variantId}
					noError
					disabled={disabled}
				/>
				{getVariant()}
				<WorkableIconDeleteButton onClick={onDelete} disabled={!editable || disabled}/>
			</GridBlock>
		</ErrorText>
	)
}

CriteriaElement.propTypes = {
	classes: PropTypes.any,
}

CriteriaElement.defaultProps = {
}

export default withStyles(style)(CriteriaElement);